import axios from "axios";
import { getCookieValue } from "./cookies";
import { logger } from "./logger";

const accountService = axios.create({
  baseURL: window.ww.wwAPI,
  timeout: 5000
});

export async function updateAssessmentId({ seqAssessmentId, market }) {
  const token = getCookieValue("wwSession");

  try {
    logger("Updating assessment id", {
      level: "info",
      customAttributes: { seqAssessmentId }
    });

    const assessmentIdUpdated = await accountService.post(
      `/account/v1/profile/update/assessment-id?market=${market}`,
      {
        seqAssessmentId
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    logger("Successfully updated assessment id", {
      level: "info",
      customAttributes: { seqAssessmentId }
    });

    return assessmentIdUpdated;
  } catch (error) {
    logger("Error updating assessment id", {
      level: "error",
      customAttributes: { seqAssessmentId, error }
    });
  }
}
